const dateSuffix = "LeaseProDateWithoutTime";

function validateDate(day, month, year) {
  if (year < 100) throw new Error('Year cannot be less than 100');
  if (month < 1 || 12 < month) throw new Error('Month number cannot be less than 1 and greater than 12');
  let daysCountInMonth = new Date(year, month, 0).getDate();
  if (day < 1 || daysCountInMonth < day) throw new Error('In ' + month + 'nth month of ' + year + 'nth year days count cannot be less than 1 and greater than ' + daysCountInMonth);
}

function convertToDate(dateInString) {
  if (dateInString == null || dateInString === '') return null;

  let splittedValues = dateInString.split('/');
  let parsedDay = parseInt(splittedValues[0]);
  let parsedMonth = parseInt(splittedValues[1]);
  let parsedYear = parseInt(splittedValues[2]);
  validateDate(parsedDay, parsedMonth, parsedYear);
  let suffix = splittedValues[3];
  if (suffix !== dateSuffix) throw new Error('Given string \"' + dateInString + '\" does not contain required suffix \"' + dateSuffix + '\"');

  return new Date(parsedYear, parsedMonth - 1, parsedDay);
}

function convertToString(date) {
  let day = date.getDate();
  let month = date.getMonth() + 1;
  let year = date.getFullYear();

  let dayString = day.toString().padStart(2, '0');
  let monthString = month.toString().padStart(2, '0');
  let yearString = year.toString().padStart(4, '0');

  return [dayString, monthString, yearString, dateSuffix].join('/');
}

const dateConverter = {
  convertToDate,
  convertToString,
};

export default dateConverter;
